import styled from 'styled-components';

const Container = styled.div`
  width: 500px;
  height: 500px;
  padding: 0 20px;
  .employee-select-dialog__feed {
    margin: unset;
    height: 100%;
  }
`;

export const Styled = {
  Container,
};
